/**
 * Direcciones antiguas de artículos del blog.
 *
 * Los primeros artículos automáticos salieron con la dirección mal formada (se
 * perdían las vocales de las letras acentuadas y la última palabra quedaba
 * cortada). Al corregirlas, las direcciones anteriores se conservan aquí para
 * que cualquier enlace ya publicado o indexado siga llevando al artículo, ahora
 * en su dirección definitiva.
 */
export const LEGACY_BLOG_SLUGS = {
  'analtica-de-ventas-5-informes-que-todo-comercio-debera-mirar':
    'analitica-de-ventas-5-informes-que-todo-comercio-deberia',
  'integracin-tpv-contabilidad-cmo-ahorrar-10-horas-al-mes-en-g':
    'integracion-tpv-contabilidad-como-ahorrar-10-horas-al-mes',
  'tpv-para-panaderas-cmo-digitalizar-tu-obrador-sin-perder-el-':
    'tpv-para-panaderias-como-digitalizar-tu-obrador-sin-perder',
};

/** Dirección definitiva de una dirección antigua, o null si ya está al día. */
export function legacyBlogSlug(slug) {
  return LEGACY_BLOG_SLUGS[slug] || null;
}